import { render, staticRenderFns } from "./ToolBarForTaskList.vue?vue&type=template&id=803d8210&"
import script from "./ToolBarForTaskList.vue?vue&type=script&lang=js&"
export * from "./ToolBarForTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports